import { Dialog, DialogContent, DialogTitle, IconButton, SvgIcon, Typography } from '@material-ui/core';
import { ReactComponent as QrCode } from 'assets/social-icons/qr-code.svg';
import QRCode from 'qrcode.react';
import React from 'react';
import { useStyles } from './dialog-qr-code.style';

type DialogQrCodeProps = {
    description: string;
};

export const DialogQrCode: React.FC<DialogQrCodeProps> = ({ description }) => {
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton onClick={handleClickOpen}>
                <SvgIcon component={QrCode} />
            </IconButton>

            <Dialog fullWidth open={open} onClose={handleClose} classes={{ paper: classes.paper }}>
                <DialogTitle className={classes.title}>
                    <Typography align="center" variant="h6">
                        {description}
                    </Typography>
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <QRCode
                        value={window.location.href}
                        size={250}
                        level="L"
                        includeMargin={false}
                        renderAs="svg"
                        imageSettings={{
                            src: require('./favicon.png'),
                            x: null,
                            y: null,
                            height: 41,
                            width: 41,
                            excavate: false,
                        }}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};
